import { render, staticRenderFns } from "./BillingCollectionItems.vue?vue&type=template&id=0878fdd8&"
import script from "./BillingCollectionItems.vue?vue&type=script&lang=ts&"
export * from "./BillingCollectionItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports